import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface QuickNavCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  badge?: string;
  to?: string;
  onClick?: () => void;
}

export default function QuickNavCard({ icon, title, description, badge, to, onClick }: QuickNavCardProps) {
  if (to) {
    return (
      <Link 
        to={to}
        className="w-full bg-white rounded-xl p-5 border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all flex items-center gap-4 group"
      >
        <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center text-gray-700 group-hover:bg-gray-100 transition-colors">
          {icon}
        </div>
        <div className="flex-1 text-left">
          <h3 className="text-sm font-medium text-gray-900">{title}</h3>
          <p className="text-xs text-gray-500 mt-0.5">{description}</p>
        </div>
        <div className="flex items-center gap-2">
          {badge && (
            <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-md">
              {badge}
            </span>
          )}
          <ArrowRight size={16} className="text-gray-400 group-hover:text-gray-600 group-hover:translate-x-0.5 transition-all" />
        </div>
      </Link>
    );
  }

  return (
    <button 
      onClick={onClick || (() => {})}
      className="w-full bg-white rounded-xl p-5 border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all flex items-center gap-4 group"
    >
      <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center text-gray-700 group-hover:bg-gray-100 transition-colors">
        {icon}
      </div>
      <div className="flex-1 text-left">
        <h3 className="text-sm font-medium text-gray-900">{title}</h3>
        <p className="text-xs text-gray-500 mt-0.5">{description}</p>
      </div>
      <div className="flex items-center gap-2">
        {badge && (
          <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-md">
            {badge}
          </span>
        )}
        <ArrowRight size={16} className="text-gray-400 group-hover:text-gray-600 group-hover:translate-x-0.5 transition-all" />
      </div>
    </button>
  );
}
